// extracted by mini-css-extract-plugin
export default {"link-list":"LinkList_link-list__BNL5q"};